import styled from 'styled-components'
import main4bg1 from 'src/assets/main/main4/main4bg.png'
import { customMedia } from 'src/styles/common/common'

const Main4SectionWrap = styled.div`
  max-width: 2560px;

  background-size: cover;
  background-image: url(${main4bg1});
  background-repeat: no-repeat;
  background-position: 50% 50%;

  text-align: center;
`

const Main4PcContent = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 1232.301px;

  > h3 {
    padding: 156px 0 24px 0;
    margin: 0;
    font-size: 60px;
    line-height: 66px;
    font-family: NanumSquareNeoExtraBold, sans-serif;
  }

  > p {
    margin: 0;
    font-size: 20px;
    line-height: 29px;
    font-family: NotoSansBold, sans-serif;
  }

`

const Main4MoContent = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 851px;
  overflow: hidden;

  > h3 {
    padding : 68px 0 12px 0;
    margin: 0;
    font-size: 24px;
    line-height: 27px;
    font-family: NanumSquareNeoExtraBold, sans-serif;
  }

  > p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    font-family: NotoSansRegular, sans-serif;
  }

  ${customMedia.lessThan('tablet_cut_line')`
    height: 812px;
  `}
`
const Main4ImgWrap = styled.div`
  position: relative;
  margin:  43px auto 0 auto;
  width: 404px;

  ${customMedia.lessThan('tablet')`
    width: 274px;
    margin-top: 80px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    margin-top: 41px;
  `}
`
const Main4Img = styled.img` 
  &.center {
    width: 404px;
    height: 807px;

    ${customMedia.lessThan('tablet')`
      width: 274px;
      height: 548px;
    `}
  }

  &.left {

    position: absolute;
    top: 315px;
    left: -250px;
    width: 200px;

    ${customMedia.lessThan('tablet')`
      top: 231px;
      left: -138px;
      width: 138px;
    `}
    
    ${customMedia.lessThan('tablet_cut_line')`
      top: 343px;
      left: -43px;
      width: 100px;
    `}
  }
  
  &.right {
    position: absolute;
    top: 55px;
    right: -250px;
    width: 200px;

    ${customMedia.lessThan('tablet')`
      top: 49px;
      right: -138px;
      width: 138px;
    `}
    
    ${customMedia.lessThan('tablet_cut_line')`
      top: 106px;
      right: -43px;
      width: 100px;
    `}
  }
`

export {
  Main4MoContent,
  Main4SectionWrap,
  Main4PcContent,
  Main4ImgWrap,
  Main4Img
}
